import get from 'lodash/get';
import { createSelector } from 'reselect';

const baseBillingCyclesSelector = (state) => get(state, 'billingCycles.billingCycles', []);
export const billingCyclesSelector = createSelector(baseBillingCyclesSelector, (billingCycles) => billingCycles);
